import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../shared/mixpanel';
import store from '../../store';

type Location = 'Sticky Filters' | 'Bottom of Listing';

/**
 * User clicked on one of the Scroll to Top CTAs
 */
export const reportScrollToTopClicked = (location: Location) => {
    mixpanel.track('Logo Maker - MPI - Scroll to Top Clicked', {
        ...store.brief.getData(),
        ...store.user.getData(),
        ...store.listingsType.getData(),
        [MIXPANEL_EVENT_PROPERTIES.LOCATION]: location,
    });
};
